'use strict';

(function () {
  'use strict';

  angular.module('msProviderConnect').config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('vnext.content.providerConnect', {
      url: 'providerconnect',
      abstract: true,
      default: '.overview',
      templateUrl: 'providerconnect/pages/provider-connect.html',
      data: {
        pageTitle: 'pageTitles.providerConnect'
      }
    }).state('vnext.content.providerConnect.overview', {
      url: '/overview',
      templateUrl: 'providerconnect/pages/overview.html',
      controllerAs: 'vm',
      controller: ['httpSvc', function (httpSvc) {
        var vm = this;
        httpSvc.get('/apiproxy/user/providerconnect/blog').then(function (blogo) {
          return vm.entries = blogo;
        });
      }]
    }).state('vnext.content.providerConnect.orientation', {
      url: '/caseplanning',
      templateUrl: 'providerconnect/pages/case-planning.html'
    }).state('vnext.content.providerConnect.blog', {
      url: '/blog',
      templateUrl: 'providerconnect/pages/blog.html',
      controllerAs: 'vm',
      controller: ['httpSvc', function (httpSvc) {
        var vm = this;
        httpSvc.get('/apiproxy/user/providerconnect/blog').then(function (blogo) {
          return vm.entries = blogo;
        });
      }]
    });
  }]);
})();